import React from 'react';
import { MenuList, Paper, Popover, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ToolTipCustomTakeDevice = ({ open, handleClose, item }) => {
    const { t } = useTranslation();

    return (
        <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={() => {
                handleClose();
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 400,
                },
            }}
        >
            <Paper>
                <MenuList>
                    <Typography
                        padding={1}
                        key={1}
                        sx={{
                            fontSize: '16px',
                            color: 'text.secondary',
                            width: 'fit-content',
                        }}
                    >
                        {t('note_grinding')}:
                    </Typography>
                    <Typography paddingLeft={0.5} variant="body1" sx={{ color: 'text.primary' }} noWrap={false}>
                        {item.note_repair_device}
                    </Typography>
                    <Typography
                        padding={1}
                        key={2}
                        sx={{
                            fontSize: '16px',
                            color: 'text.secondary',
                            width: 'fit-content',
                        }}
                    >
                        {t('new_place')}:
                    </Typography>
                    <Stack display={'flex'} flexDirection={'column'} paddingLeft={0.5}>
                        <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                            {t('cabinet')}: {item.cabinet_request_name}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('drawer')}: {item.drawer_request_name}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('cell')}:{' '}
                            {`[ ${item?.cell_request_cell_lc?.row} : ${item?.cell_request_cell_lc?.column} ]`}
                        </Typography>
                    </Stack>
                </MenuList>
            </Paper>
        </Popover>
    );
};

export default ToolTipCustomTakeDevice;
